export const FIELD_WIDTH = 960;
export const FIELD_HEIGHT = 540;

export const LEADERS = {
  vanguard: { name: "レオン", role: "突破", color: "#ffb14e", icon: "剣" },
  mage: { name: "ミラ", role: "殲滅", color: "#9d8cff", icon: "星" },
  guardian: { name: "ガルド", role: "救援", color: "#63d5b0", icon: "盾" },
};

export const TIERS = {
  rookie: { name: "新兵", subtitle: "味方と共に守る", color: "#b9c7d8" },
  elite: { name: "精鋭", subtitle: "戦線を押し返す", color: "#70c8ff" },
  hero: { name: "英雄", subtitle: "味方の道を切り拓く", color: "#ffd66d" },
};

const TIER_POWER = {
  rookie: { damage: 0.78, speed: 0.88, radius: 0.8, targets: 2, allyAura: 0.6 },
  elite: { damage: 1.2, speed: 1, radius: 1.08, targets: 4, allyAura: 1 },
  hero: { damage: 2, speed: 1.18, radius: 1.5, targets: 9, allyAura: 1.65 },
};

const UNIT_TYPES = {
  ally: { hp: 42, damage: 8, speed: 16, range: 28, radius: 10, color: "#65bfff" },
  grunt: { hp: 38, damage: 7, speed: 13, range: 25, radius: 10, color: "#ee6f76" },
  brute: { hp: 180, damage: 20, speed: 8, range: 36, radius: 17, color: "#d95c72" },
  hexer: { hp: 100, damage: 11, speed: 9, range: 105, radius: 13, color: "#bb70ed" },
  boss: { hp: 1400, damage: 27, speed: 7, range: 45, radius: 24, color: "#ff5368" },
};

let nextId = 1;
let randomState = 0x2f6e2b1;
function random() {
  randomState = (Math.imul(randomState, 1664525) + 1013904223) >>> 0;
  return randomState / 4294967296;
}
const clamp = (value, min, max) => Math.max(min, Math.min(max, value));
const dist = (a, b) => Math.hypot(a.x - b.x, a.y - b.y);

function makeUnit(type, x, y, side) {
  const spec = UNIT_TYPES[type];
  return {
    id: `${side}-${nextId++}`,
    type,
    side,
    x,
    y,
    hp: spec.hp,
    maxHp: spec.hp,
    cooldown: random() * 0.6,
    hit: 0,
    dead: false,
  };
}

function makeParticle(kind, x, y, color, text = "", size = 1) {
  return { kind, x, y, color, text, size, life: kind === "text" ? 1.1 : 0.55, maxLife: kind === "text" ? 1.1 : 0.55 };
}

function spawnFormation(battle, type, count, xBase, spread = 140) {
  for (let index = 0; index < count; index += 1) {
    const row = index % 5;
    const column = Math.floor(index / 5);
    battle.enemies.push(makeUnit(type, xBase + column * 25 + random() * 14, 170 + row * (spread / 4), "enemy"));
  }
}

export function createBattle(tier = "elite") {
  nextId = 1;
  randomState = 0x2f6e2b1;
  const partyHp = tier === "hero" ? 500 : tier === "elite" ? 460 : 520;
  const battle = {
    tier,
    time: 0,
    phase: 1,
    status: "playing",
    leader: "guardian",
    selectedTarget: null,
    speed: 1,
    gauge: 18,
    morale: 0,
    leaderSince: 0,
    formationBonusReadyAt: 0,
    lastSwitchTime: -10,
    switchFatigue: 0,
    marchTime: 0,
    message: "守護役を先頭に、味方の戦線を支えろ",
    messageLife: 5,
    flags: {},
    party: { x: 260, y: 286, hp: partyHp, maxHp: partyHp, cooldown: 0, supportCooldown: 0, shield: 0, hit: 0 },
    allies: [],
    enemies: [],
    particles: [],
    stats: { kills: 0, allyLosses: 0, switches: 0, orders: 0, furthest: 260 },
  };

  for (let index = 0; index < 14; index += 1) {
    battle.allies.push(makeUnit("ally", 155 + (index % 4) * 24, 160 + (index % 7) * 42, "ally"));
  }
  spawnFormation(battle, "grunt", 14, 535);
  return battle;
}

function phaseFor(time) {
  if (time < 75) return 1;
  if (time < 165) return 2;
  return 3;
}

function announce(battle, message) {
  battle.message = message;
  battle.messageLife = 5;
}

function spawnTimeline(battle) {
  const second = Math.floor(battle.time);
  const phase = phaseFor(battle.time);
  if (phase !== battle.phase) {
    battle.phase = phase;
    if (phase === 2) announce(battle, "敵の大群と破城兵！ 殲滅か救援で押し返せ");
    if (phase === 3) announce(battle, "魔族隊長出現！ 道を開き、斬首せよ");
  }

  const spawnKey = `spawn-${second}`;
  if (battle.flags[spawnKey]) return;
  const schedule = {
    15: ["grunt", 5], 35: ["grunt", 6], 58: ["grunt", 7],
    76: ["grunt", 10], 92: ["brute", 1], 107: ["grunt", 9],
    121: ["hexer", 1], 136: ["brute", 2], 151: ["grunt", 10],
    179: ["grunt", 8], 197: ["brute", 2], 216: ["grunt", 10],
  };
  if (schedule[second]) {
    battle.flags[spawnKey] = true;
    const [type, count] = schedule[second];
    spawnFormation(battle, type, count, type === "grunt" ? 825 : 800, 155);
  }
  if (second >= 165 && !battle.flags.boss) {
    battle.flags.boss = true;
    const boss = makeUnit("boss", 855, 286, "enemy");
    battle.enemies.push(boss);
    battle.selectedTarget = boss.id;
  }
}

function damageUnit(battle, unit, amount, color, source = "party") {
  if (!unit || unit.dead) return;
  unit.hp -= amount;
  unit.hit = 0.14;
  if (random() < 0.32) battle.particles.push(makeParticle("text", unit.x, unit.y - 18, color, `${Math.round(amount)}`));
  if (unit.hp <= 0) {
    unit.dead = true;
    battle.particles.push(makeParticle("burst", unit.x, unit.y, color, "", unit.type === "boss" ? 2.4 : 1));
    if (unit.side === "enemy") {
      battle.stats.kills += 1;
      battle.gauge = clamp(battle.gauge + (unit.type === "grunt" ? 3 : unit.type === "boss" ? 35 : 12), 0, 100);
      battle.morale = clamp(battle.morale + (source === "party" ? 3 : 1), -30, 50);
    } else {
      battle.stats.allyLosses += 1;
      battle.morale = clamp(battle.morale - 4, -30, 50);
    }
  }
}

function nearest(unit, candidates) {
  let target = null;
  let best = Infinity;
  for (const candidate of candidates) {
    if (candidate.dead) continue;
    const value = dist(unit, candidate);
    if (value < best) {
      best = value;
      target = candidate;
    }
  }
  return { target, distance: best };
}

function updateSoldiers(battle, dt) {
  const livingEnemies = battle.enemies.filter((unit) => !unit.dead);
  const livingAllies = battle.allies.filter((unit) => !unit.dead);
  const power = TIER_POWER[battle.tier];
  const auraRadius = battle.tier === "hero" ? 185 : battle.tier === "elite" ? 125 : 80;

  for (const ally of livingAllies) {
    ally.cooldown -= dt;
    ally.hit = Math.max(0, ally.hit - dt);
    const { target, distance } = nearest(ally, livingEnemies);
    if (!target) continue;
    const inspired = dist(ally, battle.party) < auraRadius;
    const speedBoost = 1 + Math.max(-0.25, battle.morale / 100) + (inspired ? 0.14 * power.allyAura : 0);
    if (distance > UNIT_TYPES.ally.range + UNIT_TYPES[target.type].radius) {
      const move = UNIT_TYPES.ally.speed * speedBoost * dt;
      ally.x += (target.x - ally.x) / distance * move;
      ally.y += (target.y - ally.y) / distance * move;
    } else if (ally.cooldown <= 0) {
      const bossCoordination = target.type === "boss" ? (battle.leader === "vanguard" ? 1 : 0.22) : 1;
      damageUnit(battle, target, UNIT_TYPES.ally.damage * (inspired ? 1.18 : 1) * bossCoordination, "#8ed7ff", "ally");
      ally.cooldown = 1.05;
    }
  }

  for (const enemy of livingEnemies) {
    enemy.cooldown -= dt;
    enemy.hit = Math.max(0, enemy.hit - dt);
    let targetInfo = nearest(enemy, livingAllies);
    const partyDistance = Math.hypot(enemy.x - battle.party.x, enemy.y - battle.party.y);
    if (partyDistance < targetInfo.distance + 20) targetInfo = { target: battle.party, distance: partyDistance };
    if (battle.tier === "hero" && battle.phase === 3 && partyDistance < 240) targetInfo = { target: battle.party, distance: partyDistance };
    const { target, distance } = targetInfo;
    if (!target) continue;
    const spec = UNIT_TYPES[enemy.type];
    if (distance > spec.range + (target.type ? UNIT_TYPES[target.type].radius : 18)) {
      const move = spec.speed * dt * (battle.phase === 2 ? 1.15 : 1);
      enemy.x += (target.x - enemy.x) / distance * move;
      enemy.y += (target.y - enemy.y) / distance * move;
    } else if (enemy.cooldown <= 0) {
      const damage = spec.damage * (enemy.type === "hexer" ? 0.75 : 1);
      if (target === battle.party) {
        const nearbySupport = livingAllies.filter((ally) => dist(ally, battle.party) < 240).length;
        const rookieEscort = battle.tier === "rookie" && battle.leader === "vanguard" && battle.phase === 3 && nearbySupport >= 4;
        const stanceFactor = battle.leader === "guardian"
          ? 0.52
          : battle.leader === "vanguard"
            ? (battle.phase < 3 ? 2.8 : rookieEscort ? 0.1 : enemy.type === "boss" ? 0.58 : 0.72)
            : 0.9;
        const shieldFactor = battle.party.shield > 0 ? 0.38 : stanceFactor;
        battle.party.hp -= damage * shieldFactor;
        battle.party.hit = 0.14;
      } else {
        damageUnit(battle, target, damage, "#ff8a95", "enemy");
      }
      enemy.cooldown = enemy.type === "boss" ? 0.85 : enemy.type === "hexer" ? 1.4 : 1.1;
    }
  }
}

function densestEnemy(enemies) {
  let best = null;
  let count = -1;
  for (const enemy of enemies) {
    let nearby = 0;
    for (const other of enemies) if (Math.hypot(enemy.x - other.x, enemy.y - other.y) < 90) nearby += 1;
    if (nearby > count) { best = enemy; count = nearby; }
  }
  return best;
}

function chosenTarget(battle, enemies) {
  const selected = enemies.find((unit) => unit.id === battle.selectedTarget);
  if (selected) return selected;
  if (battle.leader === "mage") return densestEnemy(enemies);
  if (battle.leader === "vanguard") {
    return [...enemies].sort((a, b) => {
      const priority = (unit) => unit.type === "boss" ? 4 : unit.type === "hexer" ? 3 : unit.type === "brute" ? 2 : 1;
      return priority(b) - priority(a) || a.x - b.x;
    })[0];
  }
  return [...enemies].sort((a, b) => a.x - b.x)[0];
}

function partyAttack(battle, target) {
  const power = TIER_POWER[battle.tier];
  const enemies = battle.enemies.filter((unit) => !unit.dead);
  if (battle.leader === "vanguard") {
    const reach = 78 * power.radius;
    const hits = enemies
      .filter((unit) => unit.x >= battle.party.x - 20 && unit.x <= battle.party.x + reach && Math.abs(unit.y - battle.party.y) < 48 * power.radius)
      .sort((a, b) => a.x - b.x)
      .slice(0, power.targets);
    for (const enemy of hits) {
      const strongTarget = enemy.type === "boss" || enemy.type === "brute";
      const crowdPenalty = enemy.type === "grunt" ? 0.15 : 1;
      const staleMomentum = enemy.type === "boss" && battle.time - battle.leaderSince > 18 ? 0.35 : 1;
      const heroMomentum = battle.tier === "hero" && strongTarget ? 1.3 : 1;
      damageUnit(battle, enemy, 30 * power.damage * (strongTarget ? 1.22 : 1) * crowdPenalty * staleMomentum * heroMomentum, "#ffd27a");
      enemy.x += battle.tier === "hero" ? 14 : 5;
    }
    battle.particles.push(makeParticle("slash", battle.party.x + reach * 0.5, battle.party.y, "#ffd27a", "", power.radius));
    battle.party.cooldown = battle.tier === "hero" ? 0.42 : 0.68;
  } else if (battle.leader === "mage") {
    const radius = 64 * power.radius;
    const center = target || densestEnemy(enemies);
    if (center) {
      for (const enemy of enemies.filter((unit) => dist(unit, center) < radius).slice(0, power.targets + 3)) {
        const singleTargetPenalty = enemy.type === "boss" ? 0.24 : enemy.type === "brute" ? 0.65 : 1;
        damageUnit(battle, enemy, 24 * power.damage * singleTargetPenalty, "#c8b8ff");
      }
      battle.particles.push(makeParticle("magic", center.x, center.y, "#a995ff", "", power.radius));
    }
    battle.party.cooldown = battle.tier === "hero" ? 0.72 : 1.08;
  } else {
    const nearby = enemies.filter((unit) => dist(unit, battle.party) < 66 * power.radius).slice(0, power.targets);
    for (const enemy of nearby) damageUnit(battle, enemy, 20 * power.damage, "#83e6c3");
    const healRadius = 90 * power.radius;
    for (const ally of battle.allies.filter((unit) => !unit.dead && dist(unit, battle.party) < healRadius)) {
      ally.hp = Math.min(ally.maxHp, ally.hp + 5 * power.allyAura);
    }
    battle.party.hp = Math.min(battle.party.maxHp, battle.party.hp + 10 * power.allyAura);
    battle.party.shield = Math.max(battle.party.shield, 1.2);
    battle.particles.push(makeParticle("guard", battle.party.x, battle.party.y, "#63d5b0", "", power.radius));
    battle.party.cooldown = 0.92;
  }
}

function updateParty(battle, dt) {
  const enemies = battle.enemies.filter((unit) => !unit.dead);
  if (!enemies.length) return;
  const power = TIER_POWER[battle.tier];
  const target = chosenTarget(battle, enemies);
  battle.party.cooldown -= dt;
  battle.party.shield = Math.max(0, battle.party.shield - dt);
  battle.party.hit = Math.max(0, battle.party.hit - dt);

  let desiredX = battle.party.x;
  let desiredY = target?.y ?? 286;
  if (battle.leader === "vanguard") desiredX = Math.min(target.x - 42, 845);
  if (battle.leader === "mage") desiredX = clamp(target.x - 135, 180, 770);
  if (battle.leader === "guardian") {
    const threatened = [...battle.allies].filter((unit) => !unit.dead).sort((a, b) => a.hp / a.maxHp - b.hp / b.maxHp)[0];
    desiredX = threatened ? clamp(threatened.x + 18, 170, 720) : battle.party.x;
    if (threatened) desiredY = threatened.y;
  }
  const moveSpeed = (battle.leader === "vanguard" ? 64 : battle.leader === "mage" ? 40 : 48) * power.speed;
  battle.party.x += clamp(desiredX - battle.party.x, -moveSpeed * dt, moveSpeed * dt);
  battle.party.y += clamp(desiredY - battle.party.y, -30 * dt, 30 * dt);
  battle.party.x = clamp(battle.party.x, 145, 870);
  battle.party.y = clamp(battle.party.y, 155, 400);
  battle.stats.furthest = Math.max(battle.stats.furthest, battle.party.x);

  const range = battle.leader === "mage" ? 170 : battle.leader === "vanguard" ? 105 : 80;
  if (battle.party.cooldown <= 0 && target && dist(battle.party, target) <= range * power.radius + UNIT_TYPES[target.type].radius) {
    partyAttack(battle, target);
  }
}

function updateParticles(battle, dt) {
  for (const particle of battle.particles) {
    particle.life -= dt;
    if (particle.kind === "text") particle.y -= 22 * dt;
  }
  battle.particles = battle.particles.filter((particle) => particle.life > 0);
}

function finishChecks(battle) {
  battle.allies = battle.allies.filter((unit) => !unit.dead);
  battle.enemies = battle.enemies.filter((unit) => !unit.dead);
  if (battle.party.hp <= 0 || battle.allies.length === 0) {
    battle.status = "defeat";
    announce(battle, "戦線崩壊 — 先頭を切り替えて再挑戦しよう");
    return;
  }
  if (battle.flags.boss && !battle.enemies.some((unit) => unit.type === "boss")) {
    battle.status = "march";
    battle.marchTime = 0;
    battle.morale = 50;
    announce(battle, "敵将撃破！ 三人が開いた道を全軍が進む");
    for (const ally of battle.allies) ally.x += 35;
  }
  if (battle.time > 260 && battle.status === "playing") {
    battle.status = "defeat";
    announce(battle, "時間切れ — 魔族隊長を突破役で狙おう");
  }
}

export function stepBattle(battle, rawDt) {
  if (battle.status === "march") {
    battle.marchTime += rawDt;
    battle.messageLife = Math.max(0, battle.messageLife - rawDt);
    for (const ally of battle.allies) ally.x = Math.min(920, ally.x + 72 * rawDt);
    battle.party.x = Math.min(875, battle.party.x + 38 * rawDt);
    updateParticles(battle, rawDt);
    if (battle.marchTime >= 3.4) battle.status = "victory";
    return;
  }
  if (battle.status !== "playing") {
    if (battle.status === "victory") {
      for (const ally of battle.allies) ally.x = Math.min(910, ally.x + 42 * rawDt);
    }
    updateParticles(battle, rawDt);
    return;
  }
  const dt = Math.min(rawDt * battle.speed, 0.05);
  battle.time += dt;
  battle.messageLife = Math.max(0, battle.messageLife - dt);
  spawnTimeline(battle);
  updateSoldiers(battle, dt);
  updateParty(battle, dt);
  updateParticles(battle, dt);
  finishChecks(battle);
}

export function setLeader(battle, leader) {
  if (!LEADERS[leader] || battle.leader === leader) return false;
  const previousLeader = battle.leader;
  battle.leader = leader;
  battle.leaderSince = battle.time;
  battle.switchFatigue = battle.time - battle.lastSwitchTime < 2.5 ? battle.switchFatigue + 1 : Math.max(0, battle.switchFatigue - 2);
  battle.lastSwitchTime = battle.time;
  if (battle.switchFatigue >= 3) battle.party.cooldown += Math.min(1.6, battle.switchFatigue * 0.22);
  battle.stats.switches += 1;
  battle.selectedTarget = null;
  const messages = {
    vanguard: "突破陣形 — 強敵へ踏み込み、敵列を押し破る",
    mage: "殲滅陣形 — 距離を取り、最も密集した敵を焼く",
    guardian: "救援陣形 — 傷ついた味方へ合流し、戦線を支える",
  };
  const formationBonusReady = battle.time >= battle.formationBonusReadyAt;
  if (leader === "guardian" && formationBonusReady) {
    battle.party.hp = Math.min(battle.party.maxHp, battle.party.hp + 36);
    battle.party.shield = Math.max(battle.party.shield, 1.8);
    battle.formationBonusReadyAt = battle.time + 12;
  }
  if (leader === "mage") battle.party.x = Math.max(155, battle.party.x - 16);
  if (leader === "vanguard" && battle.phase === 3 && previousLeader !== "vanguard" && formationBonusReady) {
    battle.party.hp = Math.min(battle.party.maxHp, battle.party.hp + 110);
    battle.party.shield = Math.max(battle.party.shield, 4);
    battle.morale = Math.max(battle.morale, 18);
    battle.party.x = Math.min(840, battle.party.x + 120);
    battle.gauge = 100;
    battle.formationBonusReadyAt = battle.time + 12;
  }
  announce(battle, battle.switchFatigue >= 3 ? "交代が早すぎる — 陣形が乱れている" : messages[leader]);
  return true;
}

export function useOrder(battle) {
  if (battle.gauge < 100 || battle.status !== "playing") return false;
  const power = TIER_POWER[battle.tier];
  battle.gauge = 0;
  battle.stats.orders += 1;
  const enemies = battle.enemies.filter((unit) => !unit.dead);
  if (battle.leader === "vanguard") {
    for (const enemy of enemies.filter((unit) => unit.x > battle.party.x && unit.x < battle.party.x + 360 && Math.abs(unit.y - battle.party.y) < 105)) {
      damageUnit(battle, enemy, 85 * power.damage, "#fff0a8");
      enemy.x += 28;
    }
    battle.party.x = Math.min(840, battle.party.x + 110);
    battle.particles.push(makeParticle("order", battle.party.x + 80, battle.party.y, "#ffd465", "大突撃", 2));
    announce(battle, "号令・三傑大突撃！");
  } else if (battle.leader === "mage") {
    const center = densestEnemy(enemies);
    if (center) for (const enemy of enemies.filter((unit) => dist(unit, center) < 185)) damageUnit(battle, enemy, 92 * power.damage, "#e0d7ff");
    battle.particles.push(makeParticle("order", center?.x ?? 650, center?.y ?? 280, "#b79cff", "天墜星", 2.2));
    announce(battle, "号令・天墜星！ 大群を一掃");
  } else {
    battle.party.hp = Math.min(battle.party.maxHp, battle.party.hp + 125);
    battle.party.shield = 10;
    for (const ally of battle.allies) {
      ally.hp = Math.min(ally.maxHp, ally.hp + 32 * power.allyAura);
      ally.x += 20 * power.allyAura;
    }
    battle.morale = 45;
    battle.particles.push(makeParticle("order", battle.party.x, battle.party.y, "#70e5bd", "不倒陣", 2.2));
    announce(battle, "号令・不倒陣！ 全軍、前へ");
  }
  return true;
}

export function toggleSpeed(battle) {
  battle.speed = battle.speed === 1 ? 2 : 1;
}

export function pickPriorityTarget(battle, x, y) {
  const candidates = battle.enemies.filter((unit) => !unit.dead && unit.type !== "grunt");
  const match = candidates
    .map((unit) => ({ unit, distance: Math.hypot(unit.x - x, unit.y - y) }))
    .filter(({ unit, distance }) => distance < UNIT_TYPES[unit.type].radius + 24)
    .sort((a, b) => a.distance - b.distance)[0]?.unit;
  if (!match) return null;
  battle.selectedTarget = match.id;
  announce(battle, `${match.type === "boss" ? "魔族隊長" : match.type === "brute" ? "破城兵" : "呪術兵"}を優先目標に指定`);
  return match.id;
}

export function snapshot(battle) {
  const boss = battle.enemies.find((unit) => unit.type === "boss");
  return {
    tier: battle.tier,
    time: battle.time,
    phase: battle.phase,
    status: battle.status,
    leader: battle.leader,
    gauge: battle.gauge,
    hp: battle.party.hp,
    maxHp: battle.party.maxHp,
    allies: battle.allies.length,
    enemies: battle.enemies.length,
    bossHp: boss ? boss.hp / boss.maxHp : null,
    selectedTarget: battle.selectedTarget,
    speed: battle.speed,
    message: battle.message,
    messageLife: battle.messageLife,
    stats: { ...battle.stats },
  };
}

function roundedRect(ctx, x, y, width, height, radius) {
  ctx.beginPath();
  ctx.roundRect(x, y, width, height, radius);
}

function drawHealth(ctx, unit, width) {
  if (unit.hp >= unit.maxHp) return;
  ctx.fillStyle = "rgba(9, 14, 25, .72)";
  ctx.fillRect(unit.x - width / 2, unit.y - UNIT_TYPES[unit.type].radius - 10, width, 4);
  ctx.fillStyle = unit.side === "ally" ? "#6ad3ff" : "#ff6675";
  ctx.fillRect(unit.x - width / 2, unit.y - UNIT_TYPES[unit.type].radius - 10, width * clamp(unit.hp / unit.maxHp, 0, 1), 4);
}

function drawUnit(ctx, unit, selected) {
  const spec = UNIT_TYPES[unit.type];
  ctx.save();
  if (selected) {
    ctx.strokeStyle = "#fff09b";
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.arc(unit.x, unit.y, spec.radius + 9 + Math.sin(performance.now() / 180) * 2, 0, Math.PI * 2);
    ctx.stroke();
  }
  ctx.translate(unit.x, unit.y);
  if (unit.hit > 0) ctx.globalAlpha = 0.55;
  ctx.fillStyle = "rgba(0,0,0,.25)";
  ctx.beginPath(); ctx.ellipse(0, spec.radius * 0.75, spec.radius * 1.1, spec.radius * 0.45, 0, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = spec.color;
  ctx.beginPath(); ctx.arc(0, 0, spec.radius, 0, Math.PI * 2); ctx.fill();
  ctx.fillStyle = unit.side === "ally" ? "#dff5ff" : "#3c1723";
  if (unit.type === "brute" || unit.type === "boss") {
    ctx.fillRect(-spec.radius * 0.72, -spec.radius * 0.25, spec.radius * 1.44, spec.radius * 0.68);
    ctx.fillStyle = "#fff1cc"; ctx.fillRect(-6, -3, 4, 4); ctx.fillRect(4, -3, 4, 4);
  } else if (unit.type === "hexer") {
    ctx.beginPath(); ctx.moveTo(-10, -9); ctx.lineTo(0, -24); ctx.lineTo(10, -9); ctx.fill();
    ctx.fillStyle = "#f2e6ff"; ctx.fillRect(-4, -3, 3, 3); ctx.fillRect(3, -3, 3, 3);
  } else {
    ctx.beginPath(); ctx.arc(0, -2, spec.radius * .62, Math.PI, 0); ctx.fill();
  }
  ctx.restore();
  drawHealth(ctx, unit, spec.radius * 2.2);
}

function drawParty(ctx, battle) {
  const offsets = battle.leader === "vanguard"
    ? { vanguard: [18, 0], mage: [-17, -25], guardian: [-20, 25] }
    : battle.leader === "mage"
      ? { vanguard: [-14, 25], mage: [16, 0], guardian: [-18, -24] }
      : { vanguard: [-18, -24], mage: [-16, 26], guardian: [17, 0] };
  if (battle.party.shield > 0) {
    ctx.strokeStyle = `rgba(98, 224, 184, ${0.35 + Math.sin(performance.now() / 160) * .1})`;
    ctx.lineWidth = 5;
    ctx.beginPath(); ctx.arc(battle.party.x, battle.party.y, battle.tier === "hero" ? 55 : 43, 0, Math.PI * 2); ctx.stroke();
  }
  for (const [key, [ox, oy]] of Object.entries(offsets)) {
    const hero = LEADERS[key];
    const x = battle.party.x + ox;
    const y = battle.party.y + oy;
    ctx.fillStyle = "rgba(0,0,0,.3)"; ctx.beginPath(); ctx.ellipse(x, y + 13, 14, 6, 0, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = hero.color; ctx.beginPath(); ctx.arc(x, y, key === battle.leader ? 14 : 11, 0, Math.PI * 2); ctx.fill();
    ctx.fillStyle = "#111a2b"; ctx.font = "bold 11px sans-serif"; ctx.textAlign = "center"; ctx.textBaseline = "middle"; ctx.fillText(hero.icon, x, y);
    if (key === battle.leader) {
      ctx.strokeStyle = "#fff7d4"; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(x, y, 18, 0, Math.PI * 2); ctx.stroke();
    }
  }
  const width = 72;
  ctx.fillStyle = "rgba(7,13,24,.8)"; ctx.fillRect(battle.party.x - width / 2, battle.party.y - 50, width, 7);
  ctx.fillStyle = battle.party.hp / battle.party.maxHp < .3 ? "#ff6575" : "#70e1bd";
  ctx.fillRect(battle.party.x - width / 2, battle.party.y - 50, width * clamp(battle.party.hp / battle.party.maxHp, 0, 1), 7);
}

function drawParticle(ctx, particle) {
  const progress = 1 - particle.life / particle.maxLife;
  ctx.save();
  ctx.globalAlpha = clamp(particle.life / particle.maxLife, 0, 1);
  ctx.strokeStyle = particle.color;
  ctx.fillStyle = particle.color;
  if (particle.kind === "text") {
    ctx.font = "bold 13px sans-serif"; ctx.textAlign = "center"; ctx.fillText(particle.text, particle.x, particle.y);
  } else if (particle.kind === "slash") {
    ctx.lineWidth = 8; ctx.beginPath(); ctx.arc(particle.x, particle.y, 42 * particle.size, -0.7, 0.7); ctx.stroke();
  } else if (particle.kind === "magic") {
    ctx.lineWidth = 5; ctx.beginPath(); ctx.arc(particle.x, particle.y, (18 + progress * 55) * particle.size, 0, Math.PI * 2); ctx.stroke();
  } else if (particle.kind === "guard") {
    ctx.lineWidth = 5; ctx.beginPath(); ctx.arc(particle.x, particle.y, (28 + progress * 42) * particle.size, 0, Math.PI * 2); ctx.stroke();
  } else if (particle.kind === "burst") {
    ctx.lineWidth = 6; ctx.beginPath(); ctx.arc(particle.x, particle.y, (8 + progress * 30) * particle.size, 0, Math.PI * 2); ctx.stroke();
  } else if (particle.kind === "order") {
    ctx.lineWidth = 10; ctx.beginPath(); ctx.arc(particle.x, particle.y, (25 + progress * 80) * particle.size, 0, Math.PI * 2); ctx.stroke();
    ctx.font = `900 ${20 * particle.size}px sans-serif`; ctx.textAlign = "center"; ctx.fillText(particle.text, particle.x, particle.y - 45);
  }
  ctx.restore();
}

export function drawBattle(ctx, battle) {
  const sky = ctx.createLinearGradient(0, 0, 0, FIELD_HEIGHT);
  sky.addColorStop(0, "#17253e"); sky.addColorStop(.44, "#253a4d"); sky.addColorStop(.45, "#526150"); sky.addColorStop(1, "#263b36");
  ctx.fillStyle = sky; ctx.fillRect(0, 0, FIELD_WIDTH, FIELD_HEIGHT);

  ctx.fillStyle = "rgba(255,255,255,.045)";
  for (let x = 90; x < 940; x += 85) ctx.fillRect(x, 130, 2, 295);
  ctx.fillStyle = "rgba(20,29,36,.28)"; ctx.fillRect(0, 130, FIELD_WIDTH, 295);
  ctx.fillStyle = "rgba(90,174,225,.15)"; ctx.fillRect(0, 130, clamp(battle.party.x, 0, FIELD_WIDTH), 295);
  ctx.fillStyle = "rgba(240,80,100,.12)"; ctx.fillRect(clamp(battle.party.x, 0, FIELD_WIDTH), 130, FIELD_WIDTH - battle.party.x, 295);

  ctx.fillStyle = "#47677c"; ctx.fillRect(42, 92, 68, 335);
  ctx.fillStyle = "#9bc9e3"; ctx.fillRect(61, 65, 30, 55);
  ctx.fillStyle = "#5f2734"; ctx.fillRect(875, 78, 62, 350);
  ctx.fillStyle = "#df536a"; ctx.beginPath(); ctx.moveTo(890, 78); ctx.lineTo(906, 42); ctx.lineTo(922, 78); ctx.fill();

  ctx.font = "700 12px sans-serif"; ctx.textAlign = "center";
  ctx.fillStyle = "rgba(215,240,255,.8)"; ctx.fillText("人類軍陣地", 76, 454);
  ctx.fillStyle = "rgba(255,200,206,.8)"; ctx.fillText("魔王軍陣地", 906, 454);

  for (const ally of [...battle.allies].sort((a, b) => a.y - b.y)) drawUnit(ctx, ally, false);
  for (const enemy of [...battle.enemies].sort((a, b) => a.y - b.y)) drawUnit(ctx, enemy, enemy.id === battle.selectedTarget);
  drawParty(ctx, battle);
  for (const particle of battle.particles) drawParticle(ctx, particle);

  const front = clamp((battle.party.x - 100) / 780, 0, 1);
  roundedRect(ctx, 250, 486, 460, 18, 9); ctx.fillStyle = "rgba(8,14,24,.7)"; ctx.fill();
  roundedRect(ctx, 253, 489, 454 * front, 12, 6); ctx.fillStyle = front > .72 ? "#ffcf68" : "#69c9ed"; ctx.fill();
  ctx.fillStyle = "#e8f4fa"; ctx.font = "700 11px sans-serif"; ctx.fillText("戦線", 230, 498);
}
